import { BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";

export class AttributeHtmlBridgePrototype extends HtmlBridgePrototype{
    public attributeName:string;
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new AttributeBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class AttributeBridge extends HtmlBridge{
    
    private attributeName:string;
    private binding:IBinding;
    private element:HTMLElement;
    private bindingPrototype : BindingPrototype;
    
    constructor(prototype:AttributeHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.attributeName = prototype.attributeName;
    }
    
    public set value(v: string) { 
        this._value = v; 
        this.element.setAttribute(this.attributeName,this.value);
    } public get value(): string { return this._value;} private _value: string;
    
    
    public create(view: View<ViewModel>, node: Node){
        this.element = node as HTMLElement;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'value'));
    }
    
    release() {
        this.binding.release();
    }

}